
import * as fromActions from '../actions';
import { ReclamosState } from '../models/store.models';

const initialState: ReclamosState = {
    reclamos: null,
    reclamoData: null,
    nuevaBusqueda: null
}

export function reclamosStateReducer(state: ReclamosState = initialState, action: fromActions.ReclamosActions): ReclamosState {
    switch (action.type) {
        case fromActions.SET_RECLAMOS:
            return {
                ...state,
                reclamos : action.reclamoSeteado
            }

        case fromActions.SET_RECLAMOS_DATA:
            return {
                ...state,
                reclamoData : {... action.reclamoTransferData}
            }
        case fromActions.SET_NUEVA_BUSQUEDA:
            return {
                ...state,
                nuevaBusqueda : action.nuevaBusqueda
            }
        case fromActions.UNSET_RECLAMOS:
            return {
                ...state,
                reclamos : null
            }
        case fromActions.UNSET_RECLAMOS_DATA:
            return {
                ...state,
                reclamoData : null
            }
        case fromActions.UNSET_NUEVA_BUSQUEDA:
            return {
                ...state,
                nuevaBusqueda : null
            }
        default:
            return state
    }
}
